<template>
    <b-input-group
        class="school-select-wrapper"
        :class="isVisible && 'toggled'">
        <b-form-input
            v-model="school_id"
            autofocus
            placeholder="School ID"
            ref="school_select"
            type="number"
            @keydown.enter.native="searchSchool">
        </b-form-input>
        <b-input-group-append>
            <b-button
                class="btn-input-toggler"
                v-b-tooltip.hover
                :title="$t('dashboard.change_school')"
                variant="primary"
                @click="toggleIput"
                ><i class="fad fa-school"></i
            ></b-button>
        </b-input-group-append>
    </b-input-group>
</template>

<script>
export default {
    name: 'design-2021-dashboard-admin-school-select-component',
    data() {
        return {
            school_id: '',
            isVisible: false,
        };
    },
    methods: {
        searchSchool() {
            this.alert.loading();

            this.axios.get(this.routes.selectSchool(parseInt(this.school_id))).then(
                (response) => {
                    this.alert.loaded();
                    window.location.href = this.routes.baseUrl();
                    this.$refs.school_select.$el.value = '';
                },
                (error) => {
                    this.alert.ajaxError(error, this.$t('dashboard.no_school_found_with_this_id'), false);
                    this.$refs.school_select.$el.value = '';
                },
            );
        },
        toggleIput() {
            this.isVisible = !this.isVisible;
            Vue.nextTick(() => {
                this.$refs.school_select.$el.focus();
            });
        },
    },
};
</script>

<style scoped lang="scss">
.school-select-wrapper {
    position: relative;
    border: none;
    align-self: flex-start;
    width: 35px;

    input {
        height: 35px;
        position: absolute;
        left: 0;
        width: 30px;
        background-color: $white;
        border-top-right-radius: $border-radius-content !important;
        border-bottom-right-radius: $border-radius-content !important;
        transition: all 0.5s ease;
        box-shadow: none;
        outline: none;

        &:focus {
            box-shadow: none;
            outline: none;
        }

        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }
    }

    .btn-input-toggler {
        padding: 6px;
        border-radius: $border-radius-content;
        color: $white;
        width: 35px;
        height: 35px;
        z-index: 10;
        background-color: $primary-darken-alternative;
        border: none;

        &:hover {
            background-color: darken($primary-darken-alternative, 10%);
        }
    }

    &.toggled {
        input {
            left: -150px;
            width: 150px;
            border-top-right-radius: 0 !important;
            border-bottom-right-radius: 0 !important;
        }

        .btn-input-toggler {
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
        }

        &:focus-within {
            border-radius: $border-radius-content;
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'lg')) {
    .school-select-wrapper {
        align-self: flex-start;
    }
}
</style>
